<template>
	<v-dialog v-model="dialog.display" max-width="290" persistent>
		<v-card>
			<v-card-title class="headline">{{dialog.title}}</v-card-title>
			<v-card-text>{{dialog.text}}</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn v-if="dialog.disagree" color="green darken-1" flat="flat" @click="onClickDisagree" >いいえ</v-btn>
				<v-btn v-if="dialog.agree" color="green darken-1" flat="flat" @click="onClickAgree">はい</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
export default {
	props: [
		"dialog",
	],
	methods: {
		onClickAgree: function() {
			this.$emit('agree');
		},
		onClickDisagree: function() {
			this.$emit('disagree');
		},
	},
};
</script>
